import React from "react";
import { connect } from "react-redux";
import { SelectBox } from 'devextreme-react/select-box';
import { Button } from 'devextreme-react/button';
import routes from "../../../assets/apiRoutes.json";
import TextBox from 'devextreme-react/text-box';
import { createStore } from "devextreme-aspnet-data-nojquery";
import axios from "axios";
import notify from 'devextreme/ui/notify';
import DataSource from "devextreme/data/data_source";
import ArrayStore from 'devextreme/data/array_store';
import DateBox from "devextreme-react/date-box";
import { GetDatePartOnlyDiffFormat } from "../../../common/Utils";
import {
    Validator,
    RequiredRule,
    StringLengthRule
} from 'devextreme-react/validator';
import NumberBox from 'devextreme-react/number-box';
import ValidationSummary from 'devextreme-react/validation-summary';
import {
    OrchardTypeArr,
    ElevationArr,
    SpeciesArr,
    BlockCycleArr,
    StimCycleArr,
    StimStatusArr,
    BreedingAreaArr,
    PositionArr
  } from '../const/StaticData';
let accessToken = '';
const orchardCodesSelectBox = React.createRef();
const blockCodesSelectBox = React.createRef();
const locationCodesSelectBox = React.createRef();
const orchardTypeCodesSelectBox = React.createRef();
const elevationCodesSelectBox = React.createRef();
const speciesCodesSelectBox = React.createRef();
const blockcyCleCodesSelectBox = React.createRef();
const stimCycleCodesSelectBox = React.createRef();
const stimStatusCodesSelectBox = React.createRef();
const breedingAreaCodesSelectBox = React.createRef();

class AddRametCodes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            orchard: "",
            block: "",
            location: "",
            item: "",
            lot: "",
            serialno: "",
            code: "",
            description: "",
            orchardtype: "",
            species: "",
            stimcycle: "",
            graftdate: "",
            breedingarea: "",
            elevation: "",
            blockcycle: "",
            stimstatus: "",
            plantdate: "",
            parent: "",
            rootstock: "",
            disableBlock: true,
            disableLocation: true,
            userstatus: "",
            posx: "",
            posy: ""
        };
        
        accessToken = props.oidc.user.access_token;
        this.SaveRecord = this.SaveRecord.bind(this);
        this.OrchardCodeChanged = this.OrchardCodeChanged.bind(this);
        this.BlockCodeChanged = this.BlockCodeChanged.bind(this);
        this.LocationCodeChanged = this.LocationCodeChanged.bind(this);
        this.GraftDateChanged = this.GraftDateChanged.bind(this);
        this.PlantDateChanged = this.PlantDateChanged.bind(this);
        this.LoadOrchardCodes = this.LoadOrchardCodes.bind(this);
        this.LoadBlockCodes = this.LoadBlockCodes.bind(this);
        this.LoadLocationCodes = this.LoadLocationCodes.bind(this);
        this.isValidDate = this.isValidDate.bind(this);
        this.Reset = this.Reset.bind(this);

        this.userStatusDataSource = createStore({
            key: "code",
            loadUrl: `${window._env_.REACT_APP_APIS}/${routes.RametCodes.GetUserStatusCodes}`,
            onBeforeSend: function(method, ajaxOptions) {
              ajaxOptions.headers = {
                Authorization: `Bearer ${accessToken}`
              };
            }
          });
    }

    componentDidMount() {
        this.LoadOrchardCodes();
    }
    LoadOrchardCodes() {
        axios.get(`${window._env_.REACT_APP_APIS}/${routes.Orchard.GetOrchardCodesLookUp}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        )
            .then((response) => {
                let OrchardCodesDataStore = new DataSource({
                    store: new ArrayStore({
                        data: response.data
                    }),
                    paginate: true,
                    pageSize: 100
                });
                orchardCodesSelectBox.current.instance().option(
                    "dataSource",
                    OrchardCodesDataStore
                );
                orchardCodesSelectBox.current.instance().option(
                    "acceptCustomValue",
                    false
                );
            })
            .catch((err) => {
                console.log(err, "Error in loading orchard codes");
            });
    }
    LoadBlockCodes() {
        let _id = this.state.orchard;
        axios.get(`${window._env_.REACT_APP_APIS}/${routes.Blocks.GetBlockCodesLookUp}?rowid=${_id}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        )
            .then((response) => {
                let blockCodesDataStore = new DataSource({
                    store: new ArrayStore({
                        data: response.data
                    }),
                    paginate: true,
                    pageSize: 100
                });
                blockCodesSelectBox.current.instance().option(
                    "dataSource",
                    blockCodesDataStore
                );
                blockCodesSelectBox.current.instance().option(
                    "acceptCustomValue",
                    false
                );
                this.setState({
                    block: "",
                    location: "",
                    disableLocation: true,
                    disableBlock: false
                });
            })
            .catch((err) => {
                console.log(err, "Error in loading block codes");
            });
    }
    LoadLocationCodes() {
        let _orchardid = this.state.orchard;
        let _blockid = this.state.block;
        axios.get(`${window._env_.REACT_APP_APIS}/${routes.RametCodes.GetLocationCodesLookup}?orchardrowid=${_orchardid}&blockrowid=${_blockid}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        )
            .then((response) => {
                let locationCodesDataStore = new DataSource({
                    store: new ArrayStore({
                        data: response.data
                    }),
                    paginate: true,
                    pageSize: 100
                });
                locationCodesSelectBox.current.instance().option(
                    "dataSource",
                    locationCodesDataStore
                );
                locationCodesSelectBox.current.instance().option(
                    "acceptCustomValue",
                    false
                );
                this.setState({
                    location: "",
                    disableLocation: false,
                });
            })
            .catch((err) => {
                console.log(err, "Error in loading location codes");
            });
    }
    OrchardCodeChanged(e) {
        this.setState({
            orchard: e.value,
            block: "",
            location: "",
            disableBlock: true,
            disableLocation: true
        });
        this.LoadBlockCodes();
    }
    BlockCodeChanged(e) {
        this.setState({
            block: e.value,
            location: "",
            disableLocation: true
        });
        this.LoadLocationCodes();
    }
    LocationCodeChanged(e) {
        this.setState({
            location: e.value,
        });
        var datasource = locationCodesSelectBox.current.instance().option("dataSource");
        var elementPos = datasource.items().map(function(x) {return x.id; }).indexOf(e.value);
        var objectFound = datasource.items()[elementPos];
        if(objectFound)
        {
            this.setState({
                posx : objectFound.posX,
                posy : objectFound.posY,
            });
        }
    }
    GraftDateChanged(e) {
        this.setState({
            graftdate: e.value,
        });
    }
    PlantDateChanged(e) {
        this.setState({
            plantdate: e.value,
        });
    }
    Reset() {
        this.setState({
            orchard: "",
            block: "",
            location: "",
            item: "",
            lot: "",
            serialno: "",
            code: "",
            description: "",
            orchardtype: "",
            species: "",
            stimcycle: "",
            graftdate: "",
            breedingarea: "",
            elevation: "",
            blockcycle: "",
            stimstatus: "",
            plantdate: "",
            rootstock: "",
            disableBlock: true,
            disableLocation: true,
            userstatus: "",
            posx: "",
            posy: ""
        });
    }
    isValidDate(date) {
        return date && !isNaN(Date.parse(date));
    }
    SaveRecord(e) {
        e.preventDefault();
        var rqst = this.state;
        if (this.isValidDate(rqst.plantdate))
            rqst.plantdate = GetDatePartOnlyDiffFormat(rqst.plantdate, "/");
        if (this.isValidDate(rqst.graftdate))
            rqst.graftdate = GetDatePartOnlyDiffFormat(rqst.graftdate, "/");
        axios.post(`${window._env_.REACT_APP_APIS}/${routes.RametCodes.InsertRametCode}`, rqst,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            })
            .then((res) => {
                if (res.data == "Ramet code already exist.") {
                    notify({
                        message: 'Ramet code already exist!',
                        width: 100,
                    }, 'error', 2000);
                }
                else {
                    notify({
                        message: 'Record Saved!',
                        width: 100,
                    }, 'success', 2000);
                    this.props.parentCallback();
                    this.Reset();
                }
            }).catch((err) => {
                notify({
                    message: 'Couldnt Save Data!!',
                    width: 450,
                }, 'error', 2000);
            });
    }
    render() {
        return (
            <div>
                <form onSubmit={(e) => this.SaveRecord(e)}>
                    <div className="row p-2">
                        <div className="col-md-2">
                            <label htmlFor="orchard-sb" className="field-label">
                                Orchard
                            </label>
                        </div>
                        <div className="col-md-10">
                            <SelectBox
                                ref={orchardCodesSelectBox}
                                searchEnabled={true}
                                placeholder="Select Orchard"
                                onValueChanged={this.OrchardCodeChanged}
                                displayExpr="name"
                                valueExpr="id"
                                name="orchard-sb"
                                className="w-100"
                                value={this.state.orchard}
                                acceptCustomValue={true}>
                                <Validator>
                                    <RequiredRule message="Orchard Code is required." />
                                </Validator>
                            </SelectBox>
                        </div>
                    </div>
                    <div className="row p-2">
                        <div className="col-md-2">
                            <label htmlFor="block-sb" className="field-label">
                                Block
                            </label>
                        </div>
                        <div className="col-md-10">
                            <SelectBox
                                ref={blockCodesSelectBox}
                                searchEnabled={true}
                                disabled={this.state.disableBlock}
                                placeholder="Select Block"
                                onValueChanged={this.BlockCodeChanged}
                                displayExpr="name"
                                valueExpr="id"
                                name="block-sb"
                                className="w-100"
                                value={this.state.block}
                                acceptCustomValue={true} />
                        </div>
                    </div>
                    <div className="row p-2">
                        <div className="col-md-2">
                            <label htmlFor="location-sb" className="field-label">
                                Location
                            </label>
                        </div>
                        <div className="col-md-10">
                            <SelectBox
                                ref={locationCodesSelectBox}
                                searchEnabled={true}
                                disabled={this.state.disableLocation}
                                placeholder="Select Location Code"
                                onValueChanged={this.LocationCodeChanged}
                                displayExpr="name"
                                valueExpr="id"
                                name="location-sb"
                                className="w-100"
                                value={this.state.location}
                                acceptCustomValue={true} />
                        </div>
                    </div>
                    <div className="row p-2">
                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-4 px-0">
                                    <label htmlFor="orchard-type-sb" className="field-label" style={{marginTop:"0px"}}>
                                        Row
                                    </label>
                                </div>
                                <div className="col-md-8 pl-2">
                                    {this.state.posx}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-4 px-0">
                                    <label htmlFor="elevation-sb" className="field-label" style={{marginTop:"0px"}}>
                                        Col
                                    </label>
                                </div>
                                <div className="col-md-8 pl-2">
                                    {this.state.posy}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row p-2">
                        <div className="col-md-2">
                            <label htmlFor="rametcode" className="field-label">
                                Code
                            </label>
                        </div>
                        <div className="col-md-10">
                            <TextBox
                                id="ramet-code"
                                className="input-field"
                                type="text"
                                placeholder="Enter Ramet Code"
                                onValueChanged={(data) => this.setState({ code: data.value })}
                                name="rametcode"
                                value={this.state.code}>
                                <Validator>
                                    <RequiredRule message="Code(Ramet) is required." />
                                    <StringLengthRule message="Code must have at least 3 chracters and maximum 20" min={3} max={20} />
                                </Validator>
                            </TextBox>
                        </div>
                    </div>
                    <div className="row p-2">
                        <div className="col-md-2">
                            <label htmlFor="rametdescription" className="field-label">
                                Description
                            </label>
                        </div>
                        <div className="col-md-10">
                            <TextBox
                                id="ramet-description"
                                className="input-field"
                                type="text"
                                placeholder="Enter Description"
                                onValueChanged={(data) => this.setState({ description: data.value })}
                                name="rametdescription"
                                value={this.state.description}>
                                <Validator>
                                    <StringLengthRule message="Description must have at least 3 chracters and maximum 100" min={3} max={100} />
                                </Validator>
                            </TextBox>
                        </div>
                    </div>
                    <div className="row p-2">
                        <div className="col-md-2">
                            <label htmlFor="rametparent" className="field-label">
                                Parent
                            </label>
                        </div>
                        <div className="col-md-10">
                            <TextBox
                                className="input-field"
                                type="text"
                                placeholder="Enter Parent"
                                onValueChanged={(data) => this.setState({ parent: data.value })}
                                name="ramet-parent"
                                value={this.state.parent}>
                                <Validator>
                                    <StringLengthRule message="Parent can only have maximum 50" max={50} />
                                </Validator>
                            </TextBox>
                        </div>
                    </div>
                    <div className="row p-2">
                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-4 px-0">
                                    <label htmlFor="orchard-type-sb" className="field-label">
                                        Orchard Type
                                    </label>
                                </div>
                                <div className="col-md-8 pl-2">
                                    <SelectBox
                                        ref={orchardTypeCodesSelectBox}
                                        searchEnabled={true}
                                        placeholder="Select Orchard Type"
                                        onValueChanged={(data) => this.setState({ orchardtype: data.value })}
                                        dataSource={OrchardTypeArr}
                                        displayExpr="name"
                                        valueExpr="value"
                                        name="orchard-type-sb"
                                        className="w-100"
                                        value={this.state.orchardtype}
                                        acceptCustomValue={true} />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-4 px-0">
                                    <label htmlFor="elevation-sb" className="field-label">
                                        Elevation
                                    </label>
                                </div>
                                <div className="col-md-8 pl-2">
                                    <SelectBox
                                        ref={elevationCodesSelectBox}
                                        searchEnabled={true}
                                        placeholder="Select Elevation"
                                        onValueChanged={(data) => this.setState({ elevation: data.value })}
                                        dataSource={ElevationArr}
                                        displayExpr="name"
                                        valueExpr="value"
                                        name="elevation-sb"
                                        className="w-100"
                                        value={this.state.elevation}
                                        acceptCustomValue={true} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row p-2">
                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-4 px-0">
                                    <label htmlFor="species-sb" className="field-label">
                                        Species
                                    </label>
                                </div>
                                <div className="col-md-8 pl-2">
                                    <SelectBox
                                        ref={speciesCodesSelectBox}
                                        searchEnabled={true}
                                        placeholder="Select Species"
                                        dataSource={SpeciesArr}
                                        onValueChanged={(data) => this.setState({ species: data.value })}
                                        displayExpr="name"
                                        valueExpr="value"
                                        name="species-sb"
                                        className="w-100"
                                        value={this.state.species}
                                        acceptCustomValue={true} />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-4 px-0">
                                    <label htmlFor="block-cycle-sb" className="field-label">
                                        Block Cycle
                                    </label>
                                </div>
                                <div className="col-md-8 pl-2">
                                    <SelectBox
                                        ref={blockcyCleCodesSelectBox}
                                        searchEnabled={true}
                                        placeholder="Select Block Cycle"
                                        onValueChanged={(data) => this.setState({ blockcycle: data.value })}
                                        dataSource={BlockCycleArr}
                                        displayExpr="name"
                                        valueExpr="value"
                                        name="block-cycle-sb"
                                        className="w-100"
                                        value={this.state.blockcycle}
                                        acceptCustomValue={true} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row p-2">
                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-4 px-0">
                                    <label htmlFor="stim-cycle-sb" className="field-label">
                                        Stim Cycle
                                    </label>
                                </div>
                                <div className="col-md-8 pl-2">
                                    <SelectBox
                                        ref={stimCycleCodesSelectBox}
                                        searchEnabled={true}
                                        placeholder="Select Stim Cycle"
                                        onValueChanged={(data) => this.setState({ stimcycle: data.value })}
                                        dataSource={StimCycleArr}
                                        displayExpr="name"
                                        valueExpr="value"
                                        name="stim-cycle-sb"
                                        className="w-100"
                                        value={this.state.stimcycle}
                                        acceptCustomValue={true} />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-4 px-0">
                                    <label htmlFor="stim-status-sb" className="field-label">
                                        Stim Status
                                    </label>
                                </div>
                                <div className="col-md-8 pl-2">
                                    <SelectBox
                                        ref={stimStatusCodesSelectBox}
                                        searchEnabled={true}
                                        placeholder="Select Stim Status"
                                        onValueChanged={(data) => this.setState({ stimstatus: data.value })}
                                        dataSource={StimStatusArr}
                                        displayExpr="name"
                                        valueExpr="value"
                                        name="stim-status-sb"
                                        className="w-100"
                                        value={this.state.stimstatus}
                                        acceptCustomValue={true} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row p-2">
                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-4 px-0">
                                    <label htmlFor="graft-date-dt" className="field-label">
                                        Graft Date
                                    </label>
                                </div>
                                <div className="col-md-8 pl-2">
                                    <DateBox
                                        type="date"
                                        placeholder="Graft Date"
                                        value={this.state.graftdate}
                                        name="graft-date-dt"
                                        displayFormat="shortdate"
                                        onValueChanged={this.GraftDateChanged}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-4 px-0">
                                    <label htmlFor="plant-date-dt" className="field-label">
                                        Plant Date
                                    </label>
                                </div>
                                <div className="col-md-8 pl-2">
                                    <DateBox
                                        type="date"
                                        placeholder="Plant Date"
                                        value={this.state.plantdate}
                                        name="plant-date-dt"
                                        displayFormat="shortdate"
                                        onValueChanged={this.PlantDateChanged}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row p-2">
                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-4 px-0">
                                    <label htmlFor="breeding-area-sb" className="field-label">
                                        Breeding Area
                                    </label>
                                </div>
                                <div className="col-md-8 pl-2">
                                    <SelectBox
                                        ref={breedingAreaCodesSelectBox}
                                        searchEnabled={true}
                                        placeholder="Select Breeding Area"
                                        onValueChanged={(data) => this.setState({ breedingarea: data.value })}
                                        dataSource={BreedingAreaArr}
                                        displayExpr="name"
                                        valueExpr="value"
                                        name="breeding-area-sb"
                                        className="w-100"
                                        value={this.state.breedingarea}
                                        acceptCustomValue={true} />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-4 px-0">
                                    <label htmlFor="root-stock-sb" className="field-label">
                                        Root Stock
                                    </label>
                                </div>
                                <div className="col-md-8 pl-2">
                                    <TextBox
                                        name="root-stock-sb"
                                        className="input-field"
                                        type="text"
                                        placeholder="Enter Root Stock"
                                        value={this.state.rootstock}
                                        onValueChanged={(data) => this.setState({ rootstock: data.value })}>
                                        <Validator>
                                            <StringLengthRule message="Root Stock can have maximum 20 characters" max={20} />
                                        </Validator>
                                    </TextBox>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row p-2">
                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-4 px-0">
                                    <label htmlFor="user-status-sb" className="field-label">
                                        User Status
                                    </label>
                                </div>
                                <div className="col-md-8 pl-2">
                                    <SelectBox
                                        searchEnabled={true}
                                        placeholder="Select User Status"
                                        onValueChanged={(data) => this.setState({ userstatus: data.value })}
                                        dataSource={this.userStatusDataSource}
                                        displayExpr="description1"
                                        valueExpr="code"
                                        name="user-status-sb"
                                        className="w-100"/>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            
                        </div>
                    </div>

                    <div className="row accordianLastRow">
                        <div className="col-md-12 pl-4 mt-5 mb-5">
                            <ValidationSummary id="summary" />
                            <Button
                                    text="Save Record"
                                    type="default"
                                    useSubmitBehavior={true}
                                    stylingMode="contained">
                                </Button>
                                <Button
                                    onClick={this.Reset}
                                    style={{marginLeft:'10px'}}
                                    text="Reset"
                                    useSubmitBehavior={false}
                                    stylingMode="contained">
                                </Button>
                        </div>
                    </div>
                </form >
            </div >
        );
    }
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(AddRametCodes);